import Vue from "vue";
import Router from "vue-router";
import authCheck, { initedPromise } from "@/lib/auth";

const emptyLayout = () => import("@/components/layout/base/empty");

Vue.use(Router);

// url对应permit映射
const urlPermitMap = {};

/**
interface configItem{
    priority: number; // 权重值
    component?: VueCompontent | () => VueComponent; // 页面组件，不设置会默认使用空层
    menu?: { // 菜单数据
        title: string | VueComponent | () => string; | () => VueComponent // 菜单栏标题
        icon: string // 显示 icon，使用 element-ui icon
        i18n: boolean // 是否将 title 的 string 用 vue-i18n 来解析
    },
    permit?: string | number; // 要求的权限
    children?: configItem[]; // 子页面，数组顺序影响页面在菜单上展示的顺序
    meta: object; // 页面数据
    setup?: () => configItem; // 掉用哪个后获取到 configItem，注意会覆盖上面的 component, menu, meta, children
    path: string; // 路径
}
 */
export const config = parse(
    [
        { path: "/" }, // 留个入口为空白页
        ...(process.env.VUE_APP_FUNC_PSWD_REWRITE !== "mask"
            ? [
                  {
                      path: "password/reset",
                      component: () => import("@/views/password/ResetPassword.vue")
                  }
              ]
            : []),
        // 关联业务的路由配置
        // {
        //     path: "ticket",
        //     menu: { title: "ticket.menu.self", i18n: true, icon: "el-icon-s-order" },
        //     setup: require("@/views/ticket/router").default
        // },
        {
            path: "data",
            menu: { title: "data.ticket.overview_1", i18n: true, icon: "el-icon-document-copy" },
            children: [require("@/views/zhiji/js/router").dataOverviewRobot]
        },
        {
            path: "dataAnalysis",
            menu: { title: "all.menu.dataAnalysis", icon: "el-icon-s-data", i18n: true },
            name: "dataAnalysis",
            children: [
                require("@/views/zhiji/js/router").robotHotAnalysis,
                require("@/views/zhiji/js/router").robotSatisfaction,
                require("@/views/zhiji/js/router").robotDialogLog,
                require("@/views/zhiji/js/router").serviceData,
                require("@/views/data/router").dataImRecord,
                require("@/views/data/router").ticketHotRecord,
                require("@/views/data/router").ticketSatisRecord,
                require("@/views/data/router").imHotRecord
            ]
        },
        {
            path: "monitor",
            menu: { title: "all.menu.monitor", icon: "el-icon-s-marketing", i18n: true },
            name: "monitor",
            children: [require("@/views/zhiji/js/router").robotMonitor]
        },
        {
            path: "log",
            menu: { title: "log.ticket.title", icon: "el-icon-s-marketing", i18n: true },
            name: "log",
            children: [...require("@/views/log/router").default]
        },
        {
            path: "settings",
            menu: { title: "all.menu.settings", icon: "el-icon-s-tools", i18n: true },
            name: "settings",
            children: [
                ...(process.env.VUE_APP_FUNC_USER_MANAGER !== "mask" ? [require("@/views/zhiji/js/router").robotUser] : []),
                require("@/views/zhiji/js/router").robotPortrait,
                require("@/views/zhiji/js/router").robotForm,
                require("@/views/statement/router").default,
                require("@/views/crm/router").default,
                require("@/views/zhiji/js/router").robotSensitive
            ]
        },
        // 知几业务路由配置
        ...require("@/views/zhiji/js/router").default,
        // IM业务路由配置
        ...require("@/views/agent_im/router").default
        // 私有化环境去除模块和业务配置
        // require("@/views/zhiji/js/router").businessSetting,
        // require("@/views/zhiji/js/router").moduleSetting
    ].concat([
        {
            path: "*",
            component: () => import("@/views/404")
        }
    ])
);

function getPriority({ priority = 0 } = {}) {
    return priority;
}

function parse(input, prefix = "") {
    const isArray = Array.isArray(input);
    const list = isArray ? input : [input];
    list.sort((a, b) => getPriority(b) - getPriority(a));
    const result = list.map(one => {
        const { path = "", name, component = emptyLayout, meta, menu, children, setup, permit } = one;
        const more = setup && setup();

        const allPath = `${prefix}${path ? "/" + path : ""}`;
        urlPermitMap[allPath] = permit;
        return {
            name,
            component,
            meta: { ...meta, title: (menu || {}).title },
            menu,
            permit,
            children: children && parse(children, allPath),
            ...more,
            path: path.replace(/^\/*|\/*$/g, "").trim() || "/"
        };
    });
    return isArray ? result : result[0];
}

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        // 格式请参考上面的 configItem 说明
        {
            path: "/",
            component: () => import("@/components/layout/base"),
            children: config
        }
    ]
});

router.beforeEach((to, form, next) => {
    const permit = urlPermitMap[to.path];
    initedPromise.then(() => {
        if (permit && !authCheck(permit)) {
            console.log("check no p");
            return;
        } else {
            next();
        }
    });
});

export default router;
